module.exports = __webpack_public_path__ + "img/dress_2.983aef0d.png";